/**
 * Returns a CSS class name based on the selected currency.
 * Currently, it only applies a special class for USD.
 * @param {string} currency - The currency code (e.g., 'USD', 'EUR').
 * @returns {string} - Returns 'dollar_formatter' if the currency is 'USD', otherwise an empty string.
 *
 */
export function getMoneyClass(currency: string): string {
  return currency === 'USD' ? 'dollar_formatter' : '';
};
